import { RoadmapCasesBlock } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './SurveySection.module.scss';
import EntitiesSlider from './EntitiesSlider';
import AnimatedTitle from '../AnimatedTitle';
import Button, { ButtonVariants } from '../Button';
import { pathTo } from '../../paths';

const EntitiesSection = ({ data }: { data: RoadmapCasesBlock }) => (
  <section className={classNames(styles.surveySection, styles.fullSlider)}>
    <div className={classNames(styles.titleBlock, 'container', 'home-page')}>
      {
        !!data?.title
          && (
          <h2 className={classNames(styles.title, 'header2')}>
            <AnimatedTitle title={data?.title} />
          </h2>
          )
      }
      <Button
        variant={ButtonVariants.TRANSPARENT}
        link={pathTo('services')}
        className={styles.titleButton}
        icon={(
          <svg>
            <use
              xlinkHref='/media/icon-nest.svg#iconNest'
              href='/media/icon-nest.svg#iconNest'
            />
          </svg>
          )}
      >
        View All
      </Button>
    </div>
    <div className={classNames(styles.content, 'container', 'home-page')}>
      <EntitiesSlider
        entities={data.defaultList}
        fullWidth
      />
    </div>
  </section>
);

export default EntitiesSection;
